import { esusApi } from "@/services/api";

export type ResumeIndicatorB5Params = {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	ine?: string;
};

export class ResumeIndicatorB5Data {
	totalPreventProcedures: number = 0;
	totalProcedures: number = 0;
}

export async function getResumeIndicatorB5({ uf, ibgeCode, ...params }: ResumeIndicatorB5Params) {
	const response = await esusApi.get<ResumeIndicatorB5Data>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esb/b5/resume`,
		params
	);
	return response.data || new ResumeIndicatorB5Data();
}
